import { render, staticRenderFns } from "./ModalAddWebhook.vue?vue&type=template&id=56e902d6"
import script from "./ModalAddWebhook.vue?vue&type=script&lang=js"
export * from "./ModalAddWebhook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports